/*
  CARBONIZE product section (czp) - 2026-09-12
  Two small jobs on top of Impact's own product JS:
    1. "Select your model" state: the section gets .czp-picked once any option radio is checked
       (initial load with ?variant=, or a click). CSS shows/hides the [data-czp-state] twins.
       While nothing is picked the form cannot be submitted (Enter in the quantity field, etc.).
    2. Gallery progress counter "3 / 8" next to the dashes, kept in sync with Impact's <page-dots>.
*/
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.czpReady) return;
    root.dataset.czpReady = '1';

    var section = root.closest('.shopify-section') || root;
    var form = document.forms[root.getAttribute('data-czp-form')];

    function markPicked() { section.classList.add('czp-picked'); }

    function anyChecked() {
      if (!form) return false;
      return Array.prototype.some.call(form.elements, function (el) {
        return el.matches && el.matches('input[data-option-position]:checked');
      });
    }

    if (!root.hasAttribute('data-czp-require') || anyChecked()) markPicked();

    if (form) {
      form.addEventListener('variant:change', markPicked);
      form.addEventListener('variant:change', function (e) {
        var v = e.detail && e.detail.variant;
        if (!v || typeof v.price !== 'number') return;
        root.querySelectorAll('[data-czp-deal-compare]').forEach(function (el) {
          var partner = parseInt(el.getAttribute('data-partner-price'), 10) || 0;
          el.textContent = '$' + ((v.price + partner) / 100).toFixed(2);
        });
      });
      form.addEventListener('change', function (e) {
        if (e.target && e.target.matches && e.target.matches('input[data-option-position]')) markPicked();
      });
      form.addEventListener('submit', function (e) {
        if (section.classList.contains('czp-picked')) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var picker = root.querySelector('.czp-pill-grid') || root.querySelector('.variant-picker');
        if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, true);
    }

    root.querySelectorAll('.czp-progress').forEach(function (bar) {
      var dots = bar.querySelector('page-dots');
      var counter = bar.querySelector('[data-czp-counter]');
      if (!dots || !counter) return;
      function update() {
        var items = Array.prototype.filter.call(dots.children, function (b) { return !b.hidden; });
        var i = items.findIndex(function (b) { return b.getAttribute('aria-current') === 'true'; });
        if (i >= 0) counter.textContent = (i + 1) + ' / ' + items.length;
      }
      new MutationObserver(update).observe(dots, { attributes: true, subtree: true, attributeFilter: ['aria-current', 'hidden'] });
      update();
    });
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-czp-form]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
